/**
 * 생성기 입력칸 — 주제 탭에선 주제(필수), 자료 탭에선 자료에서 다룰 범위(선택)다. 순수 UI 다.
 */
import { type KeyboardEvent, useEffect, useRef } from 'react';
import { TextArea } from '@zep-us/zus';
import { AI_GENERATE_DOCK_TOPIC_MAX_LENGTH } from '../consts/aiGenerateDock.const';

/** 입력칸이 늘어나는 상한 — 넘으면 높이는 멈추고 안에서 스크롤한다(PRD 3-4 긴 입력). 6줄(132) → 10줄(220), 10/23 지민. */
const TOPIC_MAX_ROWS = 10;
export const AiGenerateDockTopicInput = ({
  placeholder,
  value,
  onChange,
  onSubmitShortcut,
  focusKey
}: {
  placeholder: string;
  value: string;
  onChange: (topic: string) => void;
  /** Enter(조합 중 아님, Shift 없음)로 실행. 실행할 수 없으면 호출부가 무시한다. 없으면 Enter 는 아무 일도 하지 않는다. */
  onSubmitShortcut?: () => void;
  /** 바뀔 때마다 글 칸에 다시 포커스한다 — 도구(자료 종류)를 바꾸거나 코치마크가 끝나도 바로 쓸 수 있게(링크 칸은 아님, 10/23 지민). */
  focusKey?: string;
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  // 열자마자·도구를 바꾸자마자 쓸 수 있게 — 뒤 화면은 잠겨 있어 포커스가 갈 곳은 입력창뿐이다.
  useEffect(() => {
    inputRef.current?.focus();
  }, [focusKey]);
  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
      event.preventDefault();
      onSubmitShortcut?.();
    }
  };
  return <TextArea.InputField ref={inputRef} data-testid="ai-generate-dock-topic" aria-label={placeholder} placeholder={placeholder} value={value} maxLength={AI_GENERATE_DOCK_TOPIC_MAX_LENGTH} autoSize minRows={2} maxRows={TOPIC_MAX_ROWS} onChange={event => onChange(event.target.value)} onKeyDown={handleKeyDown}
  // 최소 88(글 4줄) — 시안 66 에서 한 줄 더(10/23 지민). 파일 탭 위 칸 152 = 12 + 4 + 자료 줄 36 + 12 + 88. 안쪽 여백 없음.
  className="min-h-[88px] bg-transparent p-0 text-body-lg-semibold text-default placeholder:text-assistive disabled:text-disabled" data-sentry-element="unknown" data-sentry-component="AiGenerateDockTopicInput" data-sentry-source-file="AiGenerateDockTopicInput.tsx" />;
};